import axios from 'axios';
import { API_UPLOAD_IMAGE, recordApiResponse } from '../utils/newRelic';
import toCamelCase from '../utils/camelCase';

export const getLogoUsedColors = (params) => {
  const { path, printLogoChain, printCall } = params;
  const url = `${path}${printLogoChain}${printCall}`;
  const config = {
    method: 'get',
    url,
    headers: {},
  };

  const promise = axios(config);
  return recordApiResponse(promise, API_UPLOAD_IMAGE, url, config)
    .then((response) => toCamelCase(response))
    .catch((error) => error);
};
